import React from "react";
import { InputAdornment, MenuItem, Stack, TextField } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { BED_STATUS } from "../utils/bedStatus";

// Shared cascading Department -> Ward -> Room filters (+ Status) for the bed
// census (ADR 0001 epic). All filters are applied server-side by ipd_bed/ — the
// dropdown option lists come from useBedCensusData(), which derives them from
// the currently-filtered bed list, so picking a Department naturally narrows
// the Ward/Room options.
//
// The Ward select is backed by the `room_category` filter key, NOT `ward` —
// ICU/General/ITU/Private live in room_category, while the payload's ward_code
// holds a department name. See the hierarchy note in useBedCensusData.
// Patient search is separate — client-side only, matched against the
// occupant's name/UHID/patient ID (see useBedCensusData's `search`/`setSearch`).
export default function BedCensusFilters({
  filters, setFilters, wards, rooms, search, onSearchChange,
}) {
  return (
    <Stack direction="row" spacing={1.5} flexWrap="wrap" useFlexGap>
      {onSearchChange && (
        <TextField size="small" placeholder="Search patient (name, UHID, ID)"
          value={search || ""} onChange={(e) => onSearchChange(e.target.value)}
          sx={{ minWidth: 220 }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start"><SearchIcon fontSize="small" /></InputAdornment>
            ),
          }}
        />
      )}
      <TextField select size="small" label="Ward" value={filters.room_category}
        onChange={(e) => setFilters({ room_category: e.target.value })} sx={{ minWidth: 160 }}>
        <MenuItem value="">All wards</MenuItem>
        {wards.map((w) => <MenuItem key={w.code} value={w.code}>{w.name}</MenuItem>)}
      </TextField>
      <TextField select size="small" label="Room" value={filters.room}
        onChange={(e) => setFilters({ room: e.target.value })} sx={{ minWidth: 160 }}>
        <MenuItem value="">All rooms</MenuItem>
        {rooms.map((r) => <MenuItem key={r.code} value={r.code}>{r.name}</MenuItem>)}
      </TextField>
      <TextField select size="small" label="Status" value={filters.status}
        onChange={(e) => setFilters({ status: e.target.value })} sx={{ minWidth: 160 }}>
        <MenuItem value="">All statuses</MenuItem>
        {Object.entries(BED_STATUS).map(([key, cfg]) => (
          <MenuItem key={key} value={key}>{cfg.label}</MenuItem>
        ))}
      </TextField>
    </Stack>
  );
}
